// Generate a random guest name
const adjectives = [
  'Happy', 'Cool', 'Swift', 'Bright', 'Bold', 'Calm', 'Eager', 'Gentle', 'Jolly', 'Kind',
  'Lively', 'Merry', 'Noble', 'Proud', 'Quick', 'Silent', 'Wise', 'Brave', 'Clever', 'Daring'
];

const nouns = [
  'Tiger', 'Eagle', 'Wolf', 'Lion', 'Fox', 'Bear', 'Hawk', 'Falcon', 'Panther', 'Jaguar',
  'Phoenix', 'Dragon', 'Raven', 'Owl', 'Shark', 'Whale', 'Dolphin', 'Stag', 'Stallion', 'Falcon'
];

export function generateRandomName(): string {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const number = Math.floor(Math.random() * 1000);
  return `${adjective}${noun}${number}`;
}

export function generateAnonymousUserId(): string {
  // Use crypto.randomUUID if available, otherwise fallback to timestamp + random
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `anon_${crypto.randomUUID()}`;
  }
  // Fallback for older browsers
  return `anon_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
}

